var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataConnectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 24 24",
    fill: "none",
    color: "#626262",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8V2M15 8V2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8v5a6 6 0 0 1-12 0V8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataConnectorIcon);
export default __webpack_public_path__ + "static/media/data-connector-icon.78fd537d18239f44e2fcc07c08331f78.svg";
export { ForwardRef as ReactComponent };